<app-form-input  [label]="labelTD"
	[name]="getUid() + '_SepAtt_tD'" [parentForm]="parentForm" [disabled]="disabled"
	[type]="'chips'" [maxLength]="10" [rule]="'required'" [value]="tR.td">
</app-form-input>

